// src/utils/formatCurrency.js

/**
 * Formatea un número como moneda en formato argentino
 * Ejemplo: 10400.55 -> $10.400,55
 * 
 * @param {number|string} value - Valor a formatear
 * @param {boolean} includeSymbol - Si debe incluir el símbolo $ (default: true)
 * @returns {string} - Valor formateado
 */
export const formatCurrency = (value, includeSymbol = true) => {
  // Convertir a número
  const numValue = parseFloat(value) || 0;
  
  // Formatear con separadores argentinos
  const formatted = new Intl.NumberFormat('es-AR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(numValue);
  
  // Retornar con o sin símbolo
  return includeSymbol ? `$${formatted}` : formatted;
};

/**
 * Formatea un número sin símbolo de moneda
 * Ejemplo: 10400.55 -> 10.400,55
 */
export const formatNumber = (value) => {
  return formatCurrency(value, false);
};

/**
 * Parsea un string con formato argentino a número
 * Ejemplo: "10.400,55" -> 10400.55
 */
export const parseCurrency = (value) => {
  if (typeof value === 'number') return value;
  if (!value) return 0;
  
  // Remover símbolo de pesos y espacios
  let cleaned = value.toString().replace(/\$/g, '').trim();
  
  // Reemplazar punto (separador de miles) por nada
  cleaned = cleaned.replace(/\./g, '');
  
  // Reemplazar coma (separador decimal) por punto
  cleaned = cleaned.replace(/,/g, '.');
  
  return parseFloat(cleaned) || 0;
};

export default formatCurrency;
